import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  selector: 'gtw-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LogoutComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  hostname = '';
  releaseVersion = '';

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
    this.hostname = window.location.hostname;
    this.releaseVersion =
      this.appService.SERVER_CONFIG?.configSettings?.release_version ?? '';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }
}
